<div class="box bg-white shadow-medium">
    <div class="d-flex align-items-center justify-content-center text-light-shadow-v2">
        <div class="bg-lightest-grey px-2 rounded font-bold text-center w-100 current">
            <span translate>v3-gola-tile-streaks-current</span>
            <span class="ms-1">{{ current }}</span>
        </div>
        <div class="bg-lightest-grey ms-1 px-2 rounded font-bold text-center w-100 best">
            <span translate>v3-gola-tile-streaks-best</span>
            <span class="ms-1">{{ best }}</span>
        </div>
    </div>
    <div class="d-flex align-items-center justify-content-center unit">
        <div class="text-light-shadow-v2 text-xs font-bold text-center text-line-2">{{ 'v3-global-streaks' | translate }}</div>
        <div
            [ngbTooltip]="'v3-goal-tile-streaks-tooltip' | translate: { mins: statistics.goal.declarated.seconds / 60 }"
            container="body"
            tooltipClass="secondary-tooltip"
            class="icon icon-l icon-default ms-2"
            inlineSVG="assets/icons.svg#help-2"
        ></div>
    </div>
</div>
